import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = {
  key: 0,
  class: "step-title-container"
}
const _hoisted_3 = {
  key: 1,
  class: "main-container"
}
const _hoisted_4 = {
  key: 1,
  class: "content-img-selection"
}
const _hoisted_5 = { class: "content-carousel" }
const _hoisted_6 = { class: "content-slider" }
const _hoisted_7 = { class: "slider-title" }
const _hoisted_8 = { class: "image-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["BuilderEstimatorStepTitle"], {
            title: `${$setup.props.instructions.title}s`
          }, null, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    ($setup.props.sliderOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!$setup.isDesktop)
            ? (_openBlock(), _createBlock($setup["BuilderEstimatorSelectionHouseMobile"], {
                key: 0,
                sliderOptions: $setup.props.sliderOptions,
                instructions: $setup.props.instructions,
                selectedStyle: $setup.styleSelected,
                onOnSelectOptionStyle: $setup.onSelectOptionStyle
              }, null, 8, ["sliderOptions", "instructions", "selectedStyle"]))
            : _createCommentVNode("", true),
          ($setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode($setup["CustomizeHouseSlider"], {
                    sliderImages: $setup.sliderImages,
                    showArrows: $props.isInternalColor
                  }, null, 8, ["sliderImages", "showArrows"]),
                  ($setup.isDesktop)
                    ? (_openBlock(), _createBlock($setup["SelectionInstruction"], {
                        key: 0,
                        instructions: $setup.props.instructions
                      }, null, 8, ["instructions"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString($setup.props.instructions.title) + "s options:", 1),
                  _createVNode($setup["BuilderSliderImages"], {
                    images: $setup.formateEntityForBuilderSliderImagesInterface($setup.props.sliderOptions),
                    selectedimage: $setup.styleSelected,
                    onOnSelectImage: $setup.onSelectOptionStyle,
                    isSelectFacade: true,
                    showPrice: true
                  }, {
                    "image-text": _withCtx(() => [
                      _createElementVNode("span", _hoisted_8, _toDisplayString($setup.styleSelected?.price), 1)
                    ]),
                    _: 1
                  }, 8, ["images", "selectedimage"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}